'use client';
// import { CacheProvider } from '@emotion/react';
import CssBaseline from '@mui/material/CssBaseline';
import { ThemeProvider } from '@mui/material/styles';
import React from 'react';
import '../css/monaco.css';
import IDEContextProvider from '../contexts/IDEContext';
// import createEmotionCache from '../theme/createEmotionCache';
import theme from '../theme/theme';
import ProjectContextProvider from '../contexts/ProjectContext';

// Client-side cache, shared for the whole session
// const clientSideEmotionCache = createEmotionCache();

export default function RootLayoutClient({
  children,
}: {
  children: React.ReactNode
}) {
  // Global error handling
  React.useEffect(() => {
    if (typeof window !== 'undefined') {
      window.onerror = function (msg, url, lineNo, columnNo, error) {
        if(!(msg as string).includes('ResizeObserver loop'))
          console.warn('Unhandled error:', msg, url, lineNo, columnNo, error);
        return true;
      };
      window.addEventListener('unhandledrejection', function (event) {
        console.error('Unhandled promise rejection:', event.reason);
      });
    }
  }, []);

  return (
    <html lang="en">
      <head>
        <meta name="viewport" content="initial-scale=1, width=device-width" />
      </head>
      <body style={{ margin: 0, padding: 0 }}>
        {/*<StyledEngineProvider injectFirst>
          <CacheProvider value={clientSideEmotionCache}>*/}
            <ThemeProvider theme={theme}>
              <CssBaseline />
              <IDEContextProvider>
                <ProjectContextProvider initialProject={null}>
                {children}
                </ProjectContextProvider>
              </IDEContextProvider>
            </ThemeProvider>
          {/*</CacheProvider>
        </StyledEngineProvider>*/}
      </body>
    </html>
  );
}